import { createFileRoute } from '@tanstack/react-router'
import { lazy } from 'react'

const Governance = lazy(() => import('@/components/blockpot/governance'))

export const Route = createFileRoute('/governance/')({
    component: GovernancePage,
})

function GovernancePage() {
    return <Governance />
}